'use strict';

angular.module('atex.dam').factory('DamMarkAsService', ['$http', '$location', 'DamService', '$q', 'UIConfigurationService',
function($http, $location, DamService, $q, UIConfigurationService) {
  
  var colors = [];
  var icons = [];
  var micons = [];
  var smartupdaterules =[];
  var sendcontentrules=[];
  var exports=[];

  var toJson = function(configurations) {
    var _configurations = [];
    _.each(configurations, function (configuration, id) {
      var _configuration = {
        id: id
      };

      var label, _default;
      if (configuration && configuration.label) {
        label = configuration.label;
      }

      if (configuration && configuration['default-label']) {
        _default = configuration['default-label'];
      }

      _configuration.label = UIConfigurationService.translate(label, _default);

      if (configuration && configuration.icon) {
        _configuration.icon = configuration.icon;
      }

      if (configuration && configuration.color) {
        _configuration.color = configuration.color;
      }

      _configurations.push(_configuration);
    });

    return _configurations;
  };

  return {
    loadColors: function() {
      var deferred = $q.defer();
      if (colors.length>0) {
        deferred.resolve(colors);
      } else {
        UIConfigurationService.configurations({name:'color-categorization', id:'desk-color-categorization'}).then(function (profile) {
          var configurations = atex.onecms.ObjectUtils.getByPath(profile, "configurations") || [];
          var data = toJson(configurations);

          colors.length = 0;
          Array.prototype.push.apply(colors, data);
          deferred.resolve(colors);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    loadIcons: function() {
      var deferred = $q.defer();
      if (icons.range!==undefined) {
        deferred.resolve(icons);
      } else {
        UIConfigurationService.configurations({name:'rating', id:'desk-rating'}).then(function (profile) {
          icons['range'] = atex.onecms.ObjectUtils.getByPath(profile, "configurations/rating/range") || "0";
          icons['icon'] = atex.onecms.ObjectUtils.getByPath(profile, "configurations/rating/icon") || "";
          icons['selected'] = atex.onecms.ObjectUtils.getByPath(profile, "configurations/rating/selected") || "";

          deferred.resolve(icons);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    loadMultiIcons: function() {
      var deferred = $q.defer();
      if (micons.length>0) {
        deferred.resolve(micons);
      } else {
        UIConfigurationService.configurations({name:'icon-categorization', id:'desk-icon-categorization'}).then(function (profile) {
          var configurations = atex.onecms.ObjectUtils.getByPath(profile, "configurations") || [];
          var data = toJson(configurations);

          micons.length = 0;
          Array.prototype.push.apply(micons, data);
          deferred.resolve(micons);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    loadSmartUpdateRules: function() {
      var deferred = $q.defer();
      if (smartupdaterules.length>0) {
        deferred.resolve(smartupdaterules);
      } else {
        DamService.getSmartUpdatesRulesMap().then(function(response) {
          Array.prototype.push.apply(smartupdaterules,response.data.aspects.contentData.data.updates);
          deferred.resolve(smartupdaterules);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    loadSendContentRules: function() {
      var deferred = $q.defer();
      if (sendcontentrules.length>0) {
        deferred.resolve(sendcontentrules);
      } else {
        DamService.getSendContentRulesMap().then(function(response) {
          Array.prototype.push.apply(sendcontentrules,response.data.aspects.contentData.data.configurations);
          sendcontentrules.forEach(function(rule) {
            if (!rule.icon) {
              if(rule.protocol.lastIndexOf("ftp") === 0) {
                rule.icon="fa fa-cloud";
              } else if(rule.protocol.lastIndexOf("smtp") === 0) {
                rule.icon="fa fa-envelope-o";
              } else if(rule.protocol.lastIndexOf("file") === 0) {
                rule.icon="fa fa-folder-o";
              }
            }
          });
          deferred.resolve(sendcontentrules);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    loadExports: function() {
      var deferred = $q.defer();
      if (exports.length>0) {
        deferred.resolve(exports);
      } else {
        DamService.getExports().then(function(response) {
          Array.prototype.push.apply(exports,response.data.aspects.contentData.data.export);
          deferred.resolve(exports);
        }).then(null, function(error) {
          deferred.reject(error);
        });
      }
      return deferred.promise;
    },
    getColors: function() {
      return colors;   
    },
    getIcons: function() {
      return icons;   
    },
    getMultiIcons: function() {
      return micons;   
    },
    getSmartUpdateRules: function() {
    	return smartupdaterules;
    },
    getSendContentRules: function() {
    	return sendcontentrules;
    },
    getExports: function() {
    	return exports;
    }
  };
    
}]);
